<div style="padding: 10px">
  <p mat-dialog-title>{{ data.title }}</p>
  <mat-dialog-content>{{ data.message }}</mat-dialog-content>
  <mat-dialog-actions align="end">
    <button class="cancel-btn" (click)="onNoClick()">Cancel</button>
    <button class="delete-btn" (click)="onYesClick()">Delete</button>
  </mat-dialog-actions>
</div>